import { initBrowserGame } from "./io.ts";

window.onload = () => {
  initBrowserGame();
};
